import axios from 'axios'
import { URL } from './config'

export const getSearchResults = async search => {
    const result = await axios.get(`${URL}?query=${search}`)
    return result.data.hits.hits
}
